(() => {
  const media = window.matchMedia('(min-width: 750px)');
  const init = () => {
    document.querySelectorAll('.afa-footer-accordion').forEach((details) => {
      if (details.dataset.afaReady) return;
      details.dataset.afaReady = 'true';
      details.open = media.matches;
      details.querySelector('summary').addEventListener('click', (event) => {
        if (media.matches) event.preventDefault();
      });
    });
  };
  const resize = () => document.querySelectorAll('.afa-footer-accordion').forEach((details) => { details.open = media.matches; });
  init();
  media.addEventListener('change', resize);
  document.addEventListener('shopify:section:load', init);
})();